const config = {
    'contractUphold': {
        'bigData-btn-search': '合同管理,合同维护,,合同维护-查询'
    },
    'warningTask': {
        'bigData-btn-search': '合同管理,预警任务,,预警任务-查询'
    },
    'contractSigning': {
        'bigData-btn-search': '合同管理,合同签署,,合同签署-查询'
    },
    'fileConfiguration': {
        'bigData-btn-search': '合同管理,文件配置,,文件配置-查询'
    },
    'payfileConfiguration': {
        'bigData-btn-search': '合同管理,押金管理,,押金管理-查询'
    }
};
export default config;